import { createClient } from "contentful";

const contentfulClient = createClient({
  host: process.env.REACT_APP_CONTENTFUL_HOST || "cdn.contentful.com",
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_DELIVERY_TOKEN,
});

export default contentfulClient;
